export default "__VITE_ASSET__CiJHxCIW__"